import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Register from './Register';
import RecoverPassword from './RecoverPassword';
import './Login.css';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const backgroundImages = [
    `${process.env.PUBLIC_URL}/p .jpeg`,
    `${process.env.PUBLIC_URL}/cohab.jpg`,
    `${process.env.PUBLIC_URL}/ResidencialLuizGama.jpg`,
  ];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const backgroundImageUrl = backgroundImages[currentImageIndex];
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isRecoverPasswordModalOpen, setIsRecoverPasswordModalOpen] = useState(false);

  useEffect(() => {
    if (backgroundImages.length <= 1) return;

    const intervalId = setInterval(() => {
      setIsFading(true);
      const timeoutId = setTimeout(() => {
        setCurrentImageIndex((prev) => (prev + 1) % backgroundImages.length);
        setIsFading(false);
      }, 500); // Match the CSS transition duration
      return () => clearTimeout(timeoutId);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      navigate('/home');
    } catch (error) {
      setError('Usuário ou Senha incorreto');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const openRegisterModal = () => {
    setIsRegisterModalOpen(true);
  };

  const recoverPasswordModal = () => {
    setIsRecoverPasswordModalOpen(true);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div
          className={`slide-box ${isFading ? 'fade' : ''}`}
          style={{
            backgroundImage: `url(${backgroundImageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="right-line"></div>
        </div>
        <div className="login-form">
          <div className="form-box">
            {!isRegisterModalOpen && !isRecoverPasswordModalOpen ? (
              <>
                <div className="logo-cohab">
                  <a href="https://www.saibrasil.com.br/" target="_blank" rel="noopener noreferrer">
                    <img src={`${process.env.PUBLIC_URL}/cohab_logo.png`} alt="Logo" className="icon-cohab" />
                  </a>
                </div>
                <div className="logo-centera" style={{ cursor: 'pointer' }}>
                  <a href="https://www.saibrasil.com.br/" target="_blank" rel="noopener noreferrer">
                    <img src={`${process.env.PUBLIC_URL}/geocohab.png`} alt="Logo" className="login-icon" />
                  </a>
                </div>
                <h2>Bem Vindo</h2>
                <form onSubmit={handleSubmit}>
                  <div className="input-group" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <input
                      type="email"
                      placeholder=""
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <label htmlFor="email">E-mail</label>
                  </div>
                  <div className="input-group" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder=""
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <span
                      className="toggle-password"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    >
                      {showPassword ?   <Visibility />: <VisibilityOff />}
                    </span>
                    <label htmlFor="password">Senha</label>
                    <div className="underline"></div>
                  </div>
                  {error && <p className="error-message">{error}</p>}
                  <div className="options-container">
                    <div className="recover-password-link"></div>
                    <p
                      className="recover-password-link"
                      onClick={recoverPasswordModal}
                      style={{ cursor: 'pointer' }}
                    >
                      Recuperar Senha
                    </p>
                  </div>
                  <div className="actions" style={{ display: 'flex', justifyContent: 'center', height: '4vh' }}>
                    <button type="submit" className="sign-in">Entrar</button>
                  </div>
                  <div className="register-link-container">
                    Ainda não tem cadastro?          
                    <p
                      className="register-link"
                      onClick={openRegisterModal}
                      style={{ cursor: 'pointer' }}
                    >
                      Cadastre-se aqui
                    </p>
                  </div>
                </form>
              </>
            ) : (
              <>
                {isRegisterModalOpen && (
                  <Register
                    onBack={() => setIsRegisterModalOpen(false)}
                  />
                )}
                {isRecoverPasswordModalOpen && (
                  <RecoverPassword
                    onBack={() => setIsRecoverPasswordModalOpen(false)}
                  />
                )}
              </>
            )}
          </div>
          <div className="footer">
            <p>Desenvolvido por </p>
            <a href="https://www.saibrasil.com.br/" target="_blank" rel="noopener noreferrer" style={{ cursor: 'pointer' }}>
              <img src={`${process.env.PUBLIC_URL}/LOGO.png`} alt="Logo" className="login-iconf" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;